import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";

import type { LinkedObjective } from "../api";
import { OBJECTIVE_STATUS_LABEL, OBJECTIVE_STATUS_VARIANT, formatPct } from "../constants";

/** The objectives linked to a goal, shown in the goal detail drawer: which
 *  objective, which quarter, owner, status, and current progress. */
export function LinkedObjectivesList({ objectives }: { objectives: LinkedObjective[] }) {
  if (objectives.length === 0) {
    return (
      <p className="text-sm text-muted-foreground">
        No objectives are linked to this goal yet. Assign one from the Objectives page.
      </p>
    );
  }

  return (
    <ul className="flex flex-col gap-2">
      {objectives.map((o) => (
        <li key={o.id} className="rounded-lg border border-border p-3">
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0">
              <p className="text-sm font-medium text-foreground">{o.title}</p>
              <div className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-muted-foreground">
                {o.quarter_label ? (
                  <span className="rounded bg-surface-raised px-1.5 py-0.5 font-medium text-foreground/80">
                    {o.quarter_label}
                  </span>
                ) : null}
                <span>{o.owner_name ?? "Unassigned"}</span>
              </div>
            </div>
            <Badge variant={OBJECTIVE_STATUS_VARIANT[o.status]}>
              {OBJECTIVE_STATUS_LABEL[o.status]}
            </Badge>
          </div>
          <div className="mt-2 flex items-center gap-2">
            <Progress value={o.progress_pct} className="h-1.5" />
            <span className="w-9 text-right text-xs font-semibold tabular-nums text-muted-foreground">
              {formatPct(o.progress_pct)}
            </span>
          </div>
        </li>
      ))}
    </ul>
  );
}
